// @flow
import { downloadFormFile } from 'api/fileServerApi'
import { downloadBlankPdfDocument } from 'api/pdfFillerApi'
import Spinner from 'components/Spinner'
import * as React from 'react'
import { toast } from 'react-toastify'
import Tooltip from 'ui/atoms/Tooltip'
import ButtonIcon from 'ui/ButtonIcon'
import Icons from 'ui/Icons'

type Props = {
  resourceEnabled: boolean,
  resourceId: string | number,
  resourceType: ?string,
}

function FormControlsDownloadButton({
  resourceEnabled,
  resourceId,
  resourceType,
}: Props): React.Node {
  const [isDownloadingForm, setDownloadingForm] = React.useState(false)

  const onDownloadDocument = React.useCallback(() => {
    return downloadBlankPdfDocument(`${resourceId}`)
  }, [resourceId])

  const onDownloadForm = React.useCallback(async () => {
    await downloadFormFile(resourceId)
  }, [resourceId])

  const onDownloadResource = React.useCallback(
    async (e) => {
      e.stopPropagation()
      e.preventDefault()

      setDownloadingForm(true)

      try {
        if (resourceType === 'pdf') {
          await onDownloadDocument()
          return
        }

        await onDownloadForm()
      } catch {
        toast.error('Error while downloading form.')
      } finally {
        setDownloadingForm(false)
      }
    },
    [onDownloadDocument, onDownloadForm, resourceType]
  )

  return (
    <Tooltip label="Download PDF">
      <p>
        <ButtonIcon
          rounded
          disabled={isDownloadingForm || !resourceEnabled}
          onClick={onDownloadResource}
        >
          {isDownloadingForm ? (
            <Spinner color="rgba(0,0,0,1)" size={16} />
          ) : (
            <Icons.DocumentDownload size="4" />
          )}
        </ButtonIcon>
      </p>
    </Tooltip>
  )
}

export default FormControlsDownloadButton
